module.exports = __webpack_public_path__ + "static/media/left-arrow.b46b47ea.svg";